<m-title>
    <naming-convention-label [type]="'Org'"></naming-convention-label>
</m-title>

<div class="mip-btn-container">
    <p-button
        label="Filters"
        icon="pi pi-filter-fill"
        (onClick)="toggleFilter()"
        styleClass="p-button-secondary mip-marbtn-r"></p-button>
        <button
        pButton
        class="m-button-primary ml-2"
        label="Add {{ namingConvService.organisationSingular }}"
        (click)="onAddRedirect()"></button>
</div>

<div [hidden]="!filterVisible" class="card card-pad-mod">
    <filter #filter class="groups-filter" [settings]="filterSettings"></filter>
</div>

<div class="card main-container">
    <grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" [filter]="filter" rte="1gp"></grid>
</div>
